import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { AuthStoreSelector } from '@common/selectors/authentication.selector';
import { DeliveryStoreSelector } from '@common/selectors/delivery.selector';
import { DoodDeliveryAddressModel } from '@core/models/delivery-address.model';
import { tap } from 'rxjs';

@Component({
  selector: 'app-parameters-delivery-instructions-block',
  template: `<p class="mb-2 text-center font-base text-base font-bold">
      {{ 'parameters.delivery-instructions.title' | translate }}
    </p>
    <div class="pb-6 leading-5 text-neutral-800 placeholder:text-neutral-500">
      <textarea
        [(ngModel)]="instructions"
        class="w-full resize-none rounded border border-neutral-300 bg-neutral-50 px-4 py-2.5"
        (ngModelChange)="this.instructionsChanged.emit(instructions)"
        [placeholder]="'parameters.delivery-instructions.placeholder' | translate"
      ></textarea>
    </div>`,
  standalone: true,
  imports: [FormsModule, TranslatePipe],
})
export class ParametersDeliveryInstructionsBlockComponent implements OnInit {
  @Input() instructions!: Partial<DoodDeliveryAddressModel>;

  @Output() instructionsChanged = new EventEmitter<Partial<DoodDeliveryAddressModel>>();

  addressLoading = false;

  constructor(
    private readonly deliverySelector: DeliveryStoreSelector,
    private readonly authSelector: AuthStoreSelector,
  ) {}

  ngOnInit() {
    const firebaseToken = this.authSelector.selectStatus().token;

    if (firebaseToken) {
      this.addressLoading = true;
      this.deliverySelector.selectActive
        .pipe(
          tap(newLocation => {
            if (!newLocation) {
              return;
            }
          }),
        )
        .subscribe();
    }
  }
}
